/*
* Collection of validators intended to be used for form validation
 */

export const required = (value) => {
  return (value ? undefined : 'Required');
};
